import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from '@angular/material/snack-bar';
import { GlobalError } from '@awo-care/shared-core';

@Component({
  selector: 'awo-error-dialog',
  imports: [MatButtonModule],
  template: `
    <div class="error-dialog">
      <span>{{ data.header }}</span>
      <div>{{ data.message }}</div>
      <div class="mt-4">
        <button
          mat-button
          (click)="snackBarRef.dismiss()"
        >
          {{ !data.bugReport ? 'Ok' : 'Ignorieren' }}
        </button>
        @if(data.bugReport === 'manual') {
        <button
          mat-flat-button
          (click)="reportError()"
        >
          Bug melden
        </button>
        }
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .error-dialog {
        padding: 1rem;
      }
      .mt-4 {
        margin-top: 1rem;
        display: flex;
        justify-content: space-between;
      }
    `,
  ],
})
export class ErrorDialogComponent {
  protected data = inject(MAT_SNACK_BAR_DATA) as GlobalError;
  protected snackBarRef = inject(MatSnackBarRef);
  private router = inject(Router);

  reportError(): void {
    void this.router.navigate(['/sendErrorMessage'], {
      state: { data: this.data },
    });
    this.snackBarRef.dismiss();
  }
}
